import Modal from "react-modal";
import { useNavigate } from "react-router";
import { useAuth } from "../../context/AuthContext";
import eventsAPI from "../../api/eventsAPI";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEvent } from "../../context/EventContext";
import Loader from "../Loader/Loader";
import { IoCloseSharp } from "react-icons/io5";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import { useState } from "react";
// import {
//   addDays,
//   differenceInCalendarDays,
//   startOfDay,
//   endOfDay,
// } from "date-fns";

Modal.setAppElement("#root"); // Set the app root element for accessibility

// A component to handle the create event form and modal.
// It uses the useEvent hook to access the event context and the useAuth hook to access the user context.
// It also uses the eventsAPI to create a new event.
// The create event form is a simple form that asks for the event name and event type.
// Once the form is submitted, the event is created and the user is redirected to the organizer dashboard.
// If the event is created successfully, a success toast is shown.
// If there is an error while creating the event, an error toast is shown.
// The component also has a close button that closes the modal.
// The modal is styled to have a dark background and a white foreground.
// The modal is also centered on the screen.
const CreateEvent = () => {
  const {
    isModalOpen,
    formData,
    setSubEventFormData,
    setIsModalOpen,
    setLoading,
    loading,
    setFormData,
    setLocationFormData,
    setRegistraionFormData,
    setSpeakerFormData,
    setSponsorFormData,
    setStallFormData,
    setMainEventID,
    resetForm,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    handleDateSelection,
  } = useEvent();

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      transform: "translate(-50%, -50%)",
      width: "700px", // Set width for a better view
      height: "600px", // Adjust height for calendar visibility
      background: "#fff",
      color: "#000",
      border: "1px solid #ccc",
      borderRadius: "10px",
      padding: "20px",
      zIndex: "4",
      position: "fixed",
      overflow: "auto",
    }
  };

  const navigate = useNavigate();
  const { user } = useAuth();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  //   Handles the "Next" button click in the mini event form.
  //   Sends a POST request to the backend to create a new event.
  //   If successful, it shows a success message, sets the mainEventID in the form data, and navigates to the organizer dashboard page.
  //   If the request fails, it shows an error message.
  const handleNext = async () => {
    if (!formData.event_name) {
      // If all three fields are missing, show a general error message
      toast.error("Please enter event name");
      return;
    } else if (!formData.event_type) {
      // If event name is present but type or date is missing
      toast.error("Please select event type");
      return;
    } else if (!isDateSelected()) {
      // If event name is present but type or date is missing
      toast.error("Please select dates");
      return;
    }

    setLoading(true);
    try {
      const response = await eventsAPI.post("/organizer", {
        event_name: formData.event_name,
        event_type: formData.event_type,
        organizerID: user.id,
        eventDuration: formData.eventDuration,
      });

      if (response.status === 200) {
        toast.success("Event created successfully!");
        const mainEventID = response.data;

        setMainEventID(mainEventID);

        setFormData((prev) => ({
          ...prev,
          mainEventID: mainEventID,
        }));
        setLocationFormData((prev) => ({
          ...prev,
          mainEventID: mainEventID,
        }));
        setRegistraionFormData((prev) => ({
          ...prev,
          mainEventID: mainEventID,
        }));
        setSpeakerFormData((prev) => ({
          ...prev,
          mainEventID: mainEventID,
        }));
        setSponsorFormData((prev) => ({
          ...prev,
          mainEventID: mainEventID,
        }));
        setStallFormData((prev) => ({
          ...prev,
          mainEventID: mainEventID,
        }));
        setSubEventFormData((prev) => ({
          ...prev,
          mainEventID: mainEventID,
        }));
        setLoading(false);
        navigate("/organizerdashboard");
        setIsModalOpen(false);
        setStartDate(null);
        setEndDate(null);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  //   Resets the form and closes the modal by setting setIsModalOpen to false
  const handleClose = () => {
    setIsModalOpen(false);
    resetForm();
    setStartDate(null);
    setEndDate(null);
  };

  // Helper function to check if date is selected
  const isDateSelected = () => {
    return (
      formData?.eventDuration?.length > 0 &&
      formData?.eventDuration?.every(
        (day) =>
          day.start instanceof Date &&
          !isNaN(day.start.getTime()) &&
          day.end instanceof Date &&
          !isNaN(day.end.getTime())
      )
    );
  };

  return (
    <Modal
      isOpen={isModalOpen}
      overlayClassName="createEventModal"

      style={customStyles}
      contentLabel="Create Event Modal"
    >
      <div>
        <IoCloseSharp
          onClick={() => handleClose()}
          className="close-icon"
        />
        <h2>Create Event</h2>
        <form>
          <label>
            Event Name: <span style={{ color: "red" }}>*</span>
            <input
              name="event_name"
              type="text"
              placeholder="Enter the name of your event"
              value={formData.event_name}
              onChange={handleChange}
            //required
            />
          </label>
          <label>
            Event Type: <span style={{ color: "red" }}>*</span>
            <select
              name="event_type"
              value={formData.event_type}
              onChange={handleChange}
            //required
            >
              <option value="select">Select</option>
              <option value="company retreats">Company retreats</option>
              <option value="tradeshows">Tradeshows</option>
              <option value="product launches">Product launches</option>
              <option value="conferences">Conferences</option>
              <option value="seminars">Seminars</option>
              <option value="trainings">Trainings</option>
              <option value="charity events">Charity events</option>
              <option value="hackathons">Hackathons</option>
              <option value="job fairs">Job fairs</option>
            </select>
          </label>
          <label>
            Select Dates: <span style={{ color: "red" }}>*</span>
            <DatePicker
              selected={startDate}
              onChange={handleDateSelection}
              startDate={startDate}
              endDate={endDate}
              selectsRange
              dateFormat="d-MMM-yy"
              placeholderText="Select start and end dates"
              monthsShown={2} // Show two months side by side
              minDate={new Date()} // Set the minimum date to the current date
              popperPlacement="bottom-center" // Force the calendar to open below the input
            />
          </label>
          <br />
        </form>
        <button
          type="button"
          disabled={loading}
          className="add-space"
          onClick={() => {
            handleNext();
          }}
        >
          {loading ? <Loader /> : "Next"}
        </button>
        <p>
          <span style={{ color: "red" }}>*</span> Indicates required fields
        </p>
      </div>
    </Modal>
  );
};

export default CreateEvent;
